<template>
	<div class="detail-form">
		<div class="row align-center justify-center" v-if="!isLoadingIndustry">
			<div class="detail-form__img">
				<div class="detail-form__img-file">
					<input
						class="detail-form__img-file__input"
						type="file"
						id="banner"
						accept="image/png, image/jpeg"
						@change="onFileChange"
					/>
					<img class="detail-form__img-file__banner" :src="imgSrc" alt="" v-if="imgSrc" />
					<EmptyBanner v-else />
				</div>
				<label class="detail-form__img-action" for="banner">
					{{ imgSrc ? 'Trocar Foto' : 'Adicionar Foto' }}
				</label>
			</div>
		</div>
		<div class="row" v-show="!isLoadingIndustry">
			<div class="detail-form__field">
				<label class="detail-form__field--label" for="name">Tipo de Indústria: *</label>
				<input
					class="detail-form__field--input"
					:class="[requiredFields.name ? 'alert' : '']"
					id="name"
					type="text"
					placeholder="Nome do Tipo de Indústria"
					v-model="industry.name"
				/>
				<small class="detail-form__field--input--required" v-if="requiredFields.name">
					Campo obrigatório.
				</small>
			</div>
			<div class="detail-form__field">
				<label class="detail-form__field--label" for="status">Tipo de linguagem:</label>
				<input
					class="detail-form__field--input disabled"
					id="ptBR"
					type="text"
					placeholder="PT-BR"
					value="PT-BR"
				/>
			</div>
		</div>
		<div class="row" v-show="!isLoadingIndustry">
			<div class="detail-form__field">
				<label class="detail-form__field--label" for="secondName">Tipo de Indústria: *</label>
				<input
					class="detail-form__field--input"
					:class="[requiredFields.secondName ? 'alert' : '']"
					id="secondName"
					type="text"
					placeholder="Nome do Tipo de Indústria"
					v-model="industry.secondName"
				/>
				<small class="detail-form__field--input--required" v-if="requiredFields.name">
					Campo obrigatório.
				</small>
			</div>
			<div class="detail-form__field">
				<label class="detail-form__field--label" for="status">Tipo de linguagem:</label>
				<input
					class="detail-form__field--input disabled"
					id="enUs"
					type="text"
					placeholder="EN-US"
					value="EN-US"
				/>
			</div>
		</div>
		<div class="row" v-show="!isLoadingIndustry">
			<div class="detail-form__field w-100">
				<label class="detail-form__field--label" for="color">Cor: *</label>
				<input
					class="detail-form__field--input color"
					:class="[requiredFields.color ? 'alert' : '']"
					id="color"
					type="text"
					placeholder="Cor"
					v-model="industry.color"
				/>
				<div class="color-indicator" :style="`background: ${industry.color}`"></div>
				<small class="detail-form__field--input--required" v-if="requiredFields.color">
					Campo obrigatório.
				</small>
			</div>
		</div>
		<div
			class="detail-form__actions"
			:class="newIndustry ? 'new-industry' : ''"
			v-show="!isLoadingIndustry"
		>
			<button
				class="detail-form__actions--btn outline"
				@click="handleDeleteModal()"
				v-if="!newIndustry"
			>
				Excluir Indústria
			</button>
			<button class="detail-form__actions--btn" @click="validateFields()">Salvar</button>
		</div>
		<div class="row justify-center align-center w-90-vw h-70-vh" v-if="isLoadingIndustry">
			<SpinnerIcon />
		</div>
		<DeleteModal
			:title="'Excluir Indústria'"
			:subtitle="'Tem certeza que deseja excluir esta Indústria?'"
			:loader="isLoadingIndustry"
			v-show="showDeleteModal"
			@handleDeleteModal="handleDeleteModal()"
			@confirmDelete="confirmDelete()"
		/>
	</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import {
	GET_INDUSTRY_BY_ID,
	CREATE_INDUSTRY,
	UPDATE_INDUSTRY,
	DELETE_INDUSTRY,
} from '@/store/modules/industryManagement/actions';
import SpinnerIcon from '@/components/shared/Icons/SpinnerIcon.vue';
import DeleteModal from '@/components/shared/DeleteModal/DeleteModal.vue';
import EmptyBanner from '@/components/shared/Icons/EmptyBanner.vue';
import { removeSpecialChars } from '@/utils/stringHelper';
import { copyAndRenameFile } from '@/utils/fileHelper';

export default {
	name: 'IndustryForm',
	components: { SpinnerIcon, DeleteModal, EmptyBanner },
	props: {
		isWeb: {
			required: true,
		},
	},
	data: () => ({
		industry: {
			name: '',
			secondName: '',
			language: '',
			color: '',
		},
		requiredFields: {
			name: false,
			secondName: false,
			language: false,
			color: false,
		},
		newIndustry: false,
		isEditing: false,
		showDeleteModal: false,
		imgSrc: null,
		fileName: null,
		file: null,
	}),
	created() {},
	mounted() {
		if (this.$route.query.id) {
			this.getIndustry({ vm: this, id: this.$route.query.id }).then((res) => {
				const selectedIndustry = res.data;

				selectedIndustry.forEach((item) => {
					if (item.language == 'pt-br') this.industry.name = item.name;
					if (item.language == 'en-us') this.industry.secondName = item.name;

					this.industry.color = item.color;
					this.imgSrc = item.headerUrl;
				});
			});
		} else {
			this.newIndustry = true;
		}
	},
	methods: {
		...mapActions('industryManagement', {
			getIndustry: GET_INDUSTRY_BY_ID,
			createNewIndustry: CREATE_INDUSTRY,
			updateIndustry: UPDATE_INDUSTRY,
			deleteIndustry: DELETE_INDUSTRY,
		}),
		handleDeleteModal() {
			this.showDeleteModal = !this.showDeleteModal;
		},
		onFileChange(e) {
			this.imgSrc = null;

			if (e == null) {
				this.fileName = null;
				this.file = null;
			} else {
				const file = e.target.files[0];
				const sanitizedFileName = removeSpecialChars(file.name);
				this.fileName = sanitizedFileName;
				this.file = copyAndRenameFile(file, sanitizedFileName);

				if (file.type.indexOf('image/') === 0) {
					const reader = new FileReader();

					reader.onload = (event) => {
						this.imgSrc = event.target.result;
					};

					reader.readAsDataURL(file);
					return;
				}
			}
		},
		confirmDelete() {
			this.deleteIndustry({ vm: this, id: this.$route.query.id })
				.then((res) => {
					this.handleDeleteModal();
					if (res.status == 200) {
						this.$router.push({ path: '/dashboard/config/industryType' });
					}
				})
				.catch((e) => {
					this.handleDeleteModal();
				});
		},
		createIndustry() {
			const formData = new FormData();
			const body = {
				itens: [],
				color: this.industry.color,
				headerUrl: this.fileName,
				headerUrlFull: this.fileName,
			};

			body.itens.push(
				{ name: this.industry.name, language: 'pt-br' },
				{ name: this.industry.secondName, language: 'en-us' },
			);

			formData.append('data', JSON.stringify(body));
			formData.append('file', this.file);

			this.createNewIndustry({ vm: this, body: formData }).then((res) => {
				if (res.status == 201) {
					this.$router.push({ path: '/dashboard/config/industryType' });
				}
			});
		},
		confirmUpdate() {
			const formData = new FormData();
			const body = {
				itens: [],
				color: this.industry.color,
				headerUrl: this.fileName,
				headerUrlFull: this.fileName,
			};

			body.itens.push(
				{ name: this.industry.name, language: 'pt-br' },
				{ name: this.industry.secondName, language: 'en-us' },
			);

			formData.append('data', JSON.stringify(body));

			if (this.file) {
				formData.append('file', this.file);
			}

			this.updateIndustry({ vm: this, id: this.$route.query.id, body: formData }).then((res) => {
				if (res.status == 200) {
					this.isEditing = false;
				}
			});
		},
		validateFields() {
			this.requiredFields = {
				name: true,
				secondName: true,
				color: true,
			};

			if (this.industry.name) this.requiredFields.name = false;
			if (this.industry.secondName) this.requiredFields.secondName = false;
			if (this.industry.color) this.requiredFields.color = false;

			if (!this.industry.name || !this.industry.secondName || !this.industry.color) {
				return;
			}

			if (!this.imgSrc) return this.$toastr.w('Escolha uma imagem.');

			if (!this.newIndustry) {
				this.confirmUpdate();
			} else {
				this.createIndustry();
			}
		},
	},
	computed: {
		...mapGetters('industryManagement', ['isLoadingIndustry']),
		isSafari() {
			return navigator.vendor == 'Apple Computer, Inc.';
		},
	},
	watch: {
		'industry.color'(newValue) {
			if (newValue.length >= 1 && !newValue.includes('#')) {
				this.industry.color = `#${this.industry.color}`;
			}
		},
	},
};
</script>

<style lang="scss" scoped>
@import 'IndustryForm.scss';
</style>
